import React from 'react';
import {
  Headphones,
  Image,
  Link2,
  MapPin,
  Music,
  Palette,
  Smartphone,
  Sparkles,
  UserCheck
} from 'lucide-react';

const benefitIcons = [Palette, Smartphone, Link2, Music, Image, MapPin, UserCheck, Headphones];

export function DigitalInvitesBenefitsSection({ copy }) {
  return (
    <section id="digital-invites-benefits" className="max-w-6xl mx-auto mb-20 sm:mb-28 scroll-mt-28 min-w-0">
      <div className="text-center mb-10 sm:mb-12">
        <h2 className="text-2xl sm:text-4xl font-black text-white tracking-tight break-words">{copy.sectionBenefitsTitle}</h2>
        <p className="text-white/50 mt-3 max-w-2xl mx-auto font-light break-words">{copy.sectionBenefitsLead}</p>
        <div className="w-20 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto rounded-full mt-6" />
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
        {copy.benefits.map((item, i) => {
          const Icon = benefitIcons[i] || Sparkles;
          return (
            <div
              key={item}
              className="group rounded-2xl border border-white/[0.08] bg-slate-950/40 backdrop-blur-md p-5 hover:border-amber-500/25 hover:shadow-[0_16px_48px_-24px_rgba(245,158,11,0.15)] transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mb-3 group-hover:scale-105 transition-transform">
                <Icon className="w-5 h-5 text-amber-400" aria-hidden />
              </div>
              <p className="text-sm text-white/70 font-light leading-relaxed break-words">{item}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
